/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.pageModule')
.controller('DeletePanelController', ['$rootScope', '$state', '$translate', 'BulbAuthService', 'BulbBusyService', 'BulbErrorService',
  'BulbModalService', 'BulbPageService', 'BulbUnitService', DeletePanelController]);

/**
* AngularJS controller for the delete panel.
*/
function DeletePanelController($rootScope, $state, $translate, BulbAuthService, BulbBusyService, BulbErrorService,
                 BulbModalService, BulbPageService, BulbUnitService) {
  var that = this;

  this.page = BulbPageService.page;
  that.parentUnit = BulbUnitService.parentUnit;

  this.delete = function() {
    $translate('type_draft_page_unit').then(function(avatarType) {
      $translate('modal_delete_confirm_page', {type: avatarType}).then(function (bodyText) {
        BulbModalService.show({
          titleCode: 'modal_delete_confirm_title',
          bodyText: bodyText,
          okButtonCode: 'button_delete',
          showCancelButton: true
        }).then(function () {
          $rootScope.$broadcast('navigationAwayApproval', true);

          // user confirmed the confirm delete modal
          BulbBusyService.showBusyDuring(
            BulbUnitService.deleteUnit(that.page.unit).then(function () {
              if (that.parentUnit && that.parentUnit.unitType !== 'UserUnit') {
                $state.go('unit', {unitPath: that.parentUnit.path});
              } else {
                $state.go('author', {username: BulbAuthService.currentUser.username});
              }
            }, function (error) {
              BulbErrorService.error('Cannot delete page', error);
            })
          );
        }, function (reason) {
          // user canceled the confirm delete modal: do nothing
        });
      });
    });
  };
}



